const rankingItems = [
  { rank: 1, title: '星之妖精', tag: '奇幻', hot: '98.7万', status: '连载中', change: 'up' as const },
  { rank: 2, title: '魔导师传说', tag: '魔幻', hot: '95.2万', status: '连载中', change: 'up' as const },
  { rank: 3, title: '小妖精日常', tag: '萌系', hot: '91.4万', status: '连载中', change: 'up' as const },
  { rank: 4, title: '暗夜猎魔人', tag: '奇幻', hot: '87.3万', status: '连载中', change: 'down' as const },
  { rank: 5, title: '异世界食堂', tag: '萌系', hot: '82.6万', status: '已完结', change: 'same' as const },
  { rank: 6, title: '精灵之森', tag: '魔幻', hot: '78.1万', status: '连载中', change: 'up' as const },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          热门排行
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          根据阅读热度与追更数据实时更新的漫画排行榜
        </p>

        <div className="rounded-2xl bg-background-50 border border-background-200 overflow-hidden">
          <div className="hidden sm:grid grid-cols-12 gap-4 px-6 py-4 bg-background-100 border-b border-background-200 text-xs font-medium text-foreground-500">
            <div className="col-span-1">排名</div>
            <div className="col-span-4">作品名称</div>
            <div className="col-span-2">分类</div>
            <div className="col-span-2">热度</div>
            <div className="col-span-2">状态</div>
            <div className="col-span-1">趋势</div>
          </div>

          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="grid grid-cols-1 sm:grid-cols-12 gap-2 sm:gap-4 px-4 sm:px-6 py-4 border-b border-background-100 last:border-none hover:bg-primary-50/50 transition-colors cursor-pointer"
            >
              <div className="sm:col-span-1 flex items-center gap-3 sm:gap-0">
                <span
                  className={`w-7 h-7 flex items-center justify-center rounded-full text-xs font-bold ${
                    item.rank === 1
                      ? 'bg-accent-500 text-background-50'
                      : item.rank === 2
                      ? 'bg-secondary-500 text-background-50'
                      : item.rank === 3
                      ? 'bg-primary-400 text-background-50'
                      : 'bg-background-200 text-foreground-600'
                  }`}
                >
                  {item.rank}
                </span>
                <span className="sm:hidden font-heading font-semibold text-foreground-900 text-sm">
                  {item.title}
                </span>
              </div>
              <div className="hidden sm:flex sm:col-span-4 items-center">
                <span className="font-heading font-semibold text-foreground-900 text-sm">{item.title}</span>
              </div>
              <div className="sm:col-span-2 flex items-center sm:pl-4">
                <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs">
                  {item.tag}
                </span>
              </div>
              <div className="sm:col-span-2 flex items-center sm:pl-4">
                <span className="text-sm text-foreground-600 flex items-center gap-1">
                  <i className="ri-fire-line text-accent-500 text-xs"></i>
                  {item.hot}
                </span>
              </div>
              <div className="sm:col-span-2 flex items-center sm:pl-4">
                <span className={`text-xs ${item.status === '连载中' ? 'text-primary-600' : 'text-foreground-400'}`}>
                  {item.status}
                </span>
              </div>
              <div className="sm:col-span-1 flex items-center sm:pl-4">
                {item.change === 'up' && <i className="ri-arrow-up-line text-accent-500 text-sm"></i>}
                {item.change === 'down' && <i className="ri-arrow-down-line text-primary-500 text-sm"></i>}
                {item.change === 'same' && <i className="ri-subtract-line text-foreground-400 text-sm"></i>}
              </div>

              <div className="sm:hidden flex items-center gap-2 text-xs text-foreground-500">
                <span className="flex items-center gap-1"><i className="ri-fire-line text-accent-500"></i>{item.hot}</span>
                <span>·</span>
                <span>{item.status}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}